import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { map, tap } from 'rxjs/operators';

import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '@services/storage.service';
import { ExtendedApiResponse } from './interfaces/api-status';
import { ISupportedCoin, ISupportedCoinsResponse } from './interfaces/supported-coin';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CoinsService {
  readonly staticUrl = environment.staticUrl;

  protected storageKey = 'supportedCoins';

  protected supportedCoins$: BehaviorSubject<ISupportedCoin[]>;
  cachedSupportedCoins$: Observable<ISupportedCoin[]>;

  constructor(
    private http: HttpClient,
    protected storage: StorageService,
  ) {
     this.supportedCoins$ = new BehaviorSubject<ISupportedCoin[]>(
      this.storage.get(this.storageKey, [])
    );
    this.cachedSupportedCoins$ = this.supportedCoins$.asObservable()
  }

  updateSupportedCoins(): Observable<
    ExtendedApiResponse<ISupportedCoinsResponse>
  > {
    return this.http.post<ExtendedApiResponse<ISupportedCoinsResponse>>('supported_coins', {}).pipe(
      map((res: ExtendedApiResponse<ISupportedCoinsResponse>) => {
        res.coin_list = res.coin_list.map(coin => ({
          ...coin,
          image: `${this.staticUrl}dapp-icons/${coin.logo_name}.svg`,
          precision_symbol: '0.' + '0'.repeat(coin.precision)
        }));
        return res
      }),
      tap((res: ExtendedApiResponse<ISupportedCoinsResponse>) => {        
        this.supportedCoins$.next(res.coin_list);
        this.storage.set(this.storageKey, res.coin_list);
      })
    );
  }

  getSupportedCoinsSnapshot(): ISupportedCoin[] {
    return this.supportedCoins$.value;
  }


  getSupportedCoinsByNameSnapshot(name: string): ISupportedCoin | undefined {
    return this.supportedCoins$.value.find((coin) => coin.coin_name === name);
  }

  getSupportedCoinsByIdSnapshot(id: string | number): ISupportedCoin {
    return this.supportedCoins$.value.find((coin) => coin.coin_id === Number(id)) ?? this.supportedCoins$.value[0];
  }

  getSupportedCoinsByDescSnapshot(desc: string): ISupportedCoin {
    return this.supportedCoins$.value.find((coin) => coin.desc === desc) ?? this.supportedCoins$.value[0];
  }

  getSupportedCoinsByChainIdSnapshot(chainId?: number): ISupportedCoin | undefined {
    return this.supportedCoins$.value.find((coin) => coin.chain_id === chainId);
  }
}
